module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("我分享的会员")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217a72d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/myRecommend.vue
// module id = 1548
// module chunks = 1